import { render, staticRenderFns } from "./Cust.vue?vue&type=template&id=5ba2e5e4&"
import script from "./Cust.vue?vue&type=script&lang=js&"
export * from "./Cust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports